// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3":"5b14e09ac57312d6","1646":"510ae2f2cc90e781","1970":"2ec3b90c60a5a4bf","2532":"19d79bf59c7e77cd","5139":"715107020b82813d","6177":"0d81aefac7ef2777"}[chunkId] + ".js";
};